import { Splide } from "@splidejs/splide";

let defaultOptions = {
  perPage: 1,
  type: 'loop',
  pagination: false,
  autoplay: true
}

const elementVisibleInPercent = (element) => {
  return new Promise((resolve, reject) => {
      const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
              resolve(Math.floor(entry.intersectionRatio * 100));
              clearTimeout(timeout);
              observer.disconnect();
          });
      });

      observer.observe(element);
      // Probably not needed, but in case something goes wrong.
      const timeout = setTimeout(() => {
          reject();
      }, 500);
  });
};

export default (options = defaultOptions, fancy = false) => ({
  index: 0,

  max: 0,

  options: options,

  init() {
    let preview;
    let splide = new Splide(this.$refs.slider, this.options);

    if (fancy === true) {
      preview = new Splide(this.$refs.sliderPreview, {
        type: 'fade',
        pagination: false,
        arrows: false,
        breakpoints: {
          767: {
            destroy: true
          }
        }
      })

      splide.sync(preview);
    }

    splide.mount();

    if (fancy === true) {
      preview.mount()
    }

    this.index = splide.index;
    this.max = splide.length;

    splide.on('move', newIndex => {
      this.index = newIndex;
    });

    splide.on('visible', slide => {
      slide.slide.style.setProperty('--current-position', 1);

      if (fancy) {
        splide.splides[0].splide.Components.Slides.forEach(previewSlide => {
          if (slide.index == previewSlide.index) {
            previewSlide.slide.style.setProperty('--current-position', 1)
          } else {
            previewSlide.slide.style.setProperty('--current-position', 0)
          }
        });
      }
    });

    splide.on('hidden', slide => {
      slide.slide.style.setProperty('--current-position', 0);
    });

    splide.on('dragging', () => {
      splide.Components.Slides.forEach(slide => {
        if (slide.isWithin(splide.index, 1)) {
          const percentage = elementVisibleInPercent(slide.slide).then((response) => {
            slide.slide.style.setProperty('--current-position', response + '%');

            if (fancy) {
              splide.splides[0].splide.Components.Slides.getAt(slide.index).slide.style.setProperty('--current-position', response + '%');
            }
          });
        }
      });
    })

    splide.on('dragged', () => {
      let index = splide.index;

      splide.Components.Slides.forEach(slide => {
        console.log(1);
        let opacity = 0;

        if (index == slide.index) {
          opacity = 1;
        }

        slide.slide.style.setProperty('--current-position', opacity);

        if (fancy) {
          splide.splides[0].splide.Components.Slides.getAt(slide.index).slide.style.setProperty('--current-position', opacity);
        }
      }) 
    })
  }
})